module.exports = __webpack_public_path__ + "img/bi.svg";